import { useQuery } from "@tanstack/react-query";
import { getMasterTable } from "@/services/get-master-table/getMasterTable";
import { masterTableKeys } from "@/queries/masterTableKeys";
import { getRecordsTableMasterByCode, getValueRecordTableMasterBycode } from "@/utils/commoms";
import { FILTER_TYPES_MASTER, MasterFilter } from "@/types/master-filter";
import type { ResultMasterMap } from "@/interfaces/table-master";


export interface UseMasterTableOptions {
  enabled?: boolean;
}

export const useTableMasterService = (
  filter: MasterFilter = { type: FILTER_TYPES_MASTER.MASTER },
  options: UseMasterTableOptions = {}
) => {
  const { enabled = true } = options;

  const masterTableQuery = useQuery<ResultMasterMap[] | null>({
    queryKey: masterTableKeys.byTypeFilter(filter),
    queryFn: () => getMasterTable(filter),
    enabled: enabled && !!filter,
  });

  return {
    ...masterTableQuery,
    getRecords: (codeTable: number) => getRecordsTableMasterByCode(masterTableQuery.data, codeTable),
    getValueByCode: (codeTable: number, codeRecord: number) => getValueRecordTableMasterBycode(masterTableQuery.data, codeTable, codeRecord)
  };
};
